export default __webpack_public_path__ + "static/media/Grips of the Ghost of the Veldt.7d90404e.jpg";